import { ReactElement } from 'react';
import { IAuthProviderConfig } from '../../../IAuthProviderConfig.types';
import { IAuthProviderUiProps } from '../../../IAuthProviderUiProps.types';
import { useAssentlyProvider } from '../hooks/useAssentlyProvider';
import { BankIDNOButton, BankIDNOButtonProps } from './BankIDNOButton';

export type IBankIdLoginProps = IAuthProviderUiProps & {
  onCanceled: IAuthProviderConfig['onCanceled'];
  serviceSourceUrl: string;
};

export const BankIdLogin = ({
  action = 'login',
  language = 'nb',
  onStart,
  onSuccess,
  onError,
  onCanceled,
  axoApiUrl,
  serviceSourceUrl,
}: IBankIdLoginProps): ReactElement => {
  const { authenticate } = useAssentlyProvider({
    onSuccess,
    onError,
    onCanceled,
    onStart,
    axoApiUrl,
    serviceSourceUrl,
  });

  return (
    <BankIDNOButton
      action={action}
      language={language as BankIDNOButtonProps['language']}
      onClick={authenticate}
      data-testid="bankid-login"
    />
  );
};
